import { useQuery } from "react-query";
import { getEmailSettings } from "../services/user/EmailSettings";
import { key_EmailSetings } from "../utils/constants";

export const useEmailSettings = (options: any = null) =>
  useQuery([key_EmailSetings], () => getEmailSettings(), {
    // A ausência de configuração é uma resposta de erro legítima: sem
    // `retry: false` o ecrã ficava preso no spinner durante 3 tentativas.
    retry: false,
    ...(options ?? {}),
  });
